import _Box from "@material-ui/core/esm/Box";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useStyles } from "./MessagesStyles";
import { MessageContainer } from "./MessageContainer/MessageContainer";
import { Image, Text, Audio, File, Video } from "./MessagesComponents";
import { Album } from "./MessagesComponents/Album/Album";
import { useVisualMedia } from "./hooks/useVisualMedia";
import { useBottomMover } from "./hooks/useBottomMover";
import { ReplyToMessagePreview } from "./ReplyToMessagePreview/ReplyToMessagePreview";
import { useChat } from "../Chat";
import { useAuth } from "../Auth";
import { useInfiniteScroll } from "../Chat/hooks/useInfiniteScroll";
const components = {
  text: Text,
  image: Image,
  audio: Audio,
  file: File,
  video: Video,
  album: Album
};

var _ref2 = /*#__PURE__*/_jsx(ReplyToMessagePreview, {});

const Messages = _ref => {
  let handleEditMessage = _ref.handleEditMessage,
      handleDeleteMessage = _ref.handleDeleteMessage,
      selectedChat = _ref.selectedChat;

  const _useChat = useChat(),
        messages = _useChat.messages,
        pendingMessages = _useChat.pendingMessages,
        replyingTo = _useChat.replyingTo,
        pages = _useChat.pages;

  const classes = useStyles();

  const _useVisualMedia = useVisualMedia(messages),
        handleOpenCarousel = _useVisualMedia.handleOpenCarousel;

  const _useAuth = useAuth(),
        user = _useAuth.user;

  useBottomMover('chatMessagesContainer', user.id);
  useInfiniteScroll();
  useEffect(() => document.getElementById('chatInput').focus(), [messages]);
  return React.createElement(React.Fragment, null, _jsx(_Box, {
    id: 'chatMessagesContainer',
    className: "".concat(classes.container, " ").concat(!!replyingTo && 'paddingBottom')
  }, void 0, [...messages, ...(pages.current[0] === 1 ? pendingMessages : [])].map((message, index, array) => {
    const fromUser = message.from === user.id;
    const anchor = fromUser ? 'right' : 'left';
    const header = false; // !!(fromUser ? null : message.from);

    const pastMessageIsFromSameUser = message.from === array[index - 1]?.from;
    const nextMessageIsFromSameUser = message.from === array[index + 1]?.from;
    const Component = components[message.type];
    return Component && _jsx(MessageContainer, {
      anchor: anchor,
      messageIsFromUser: fromUser,
      header: !(selectedChat?.type === 'private') && !pastMessageIsFromSameUser && header,
      message: message,
      lessMargin: nextMessageIsFromSameUser,
      fullWidth: message.type === 'audio',
      hardMaxWidth: ['audio', 'video', 'image', 'album', 'file'].includes(message.type),
      handleDeleteMessage: handleDeleteMessage,
      handleEditMessage: handleEditMessage
    }, message.id, _jsx(Component, {
      message: message,
      content: message.content,
      anchor: anchor,
      topSeparation: true // topSeparation={
      //   fromUser ||
      //   pastMessageIsFromSameUser ||
      //   selectedChat?.type === 'private'
      // }
      ,
      handleOpenCarousel: handleOpenCarousel
    }));
  }), !!replyingTo && _ref2));
};

export default Messages;